(function (ws) {
    'use strict';
    ws.views.endusermodal = ws.views.modal.extend({
        /**
         * onOpen override - apart from opening the modal, reset page-size to default 25
         */
        onOpen: function () {
            this.$('form').find('input[type=text]').val('');
            this.$('#tbl-simple-page-size').val(25);
            ws.views.modal.prototype.onOpen.call(this);
        },

        /**
         * closeModal override - apart from closing the modal, reset inputs and tabs to their initial state
         */
        closeModal: function () {
            this.$('#qut-search-enduser-result-table').hide().dataTable().fnClearTable();
            this.$('.qut-search-enduser-table').hide();
            this.$('.qut-enduser-errors').hide();

            // trigger super closeModal
            ws.views.modal.prototype.closeModal.call(this);
        }
    });
})(westcon);
